import { render, staticRenderFns } from "./PasswordResetSuccess.vue?vue&type=template&id=6880dad6"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports